// Registre de propriété d'un jeton : claims/{tid} (A11, 06/10/2026, audit
// Recette D2). Avant, l'app listait tous les scans d'un jeton (lecture
// publique) pour trouver le propriétaire (1er scan) et l'historique ; les
// règles ne savent pas réserver une liste aux requêtes filtrées sur un jeton,
// donc tout `scans` était listable. Désormais :
//   claims/{tid} = { owner, aid, firstScanAt, seen: { uid: date serveur } }
// lu par identifiant de jeton seulement, créé par le 1er scanneur et complété
// une fois par chaque nouveau scanneur, dans le lot du scan.
import { FieldPath, serverTimestamp } from "firebase/firestore";

// Au-delà, plus d'inscription ni de don (règle : seen.size() < 200).
export const SEEN_MAX = 200;

const secondes = (d) => d?.seconds ?? Number.MAX_SAFE_INTEGER;

// Les scanneurs du registre sous la forme des anciens documents `scans`
// ({ uid, date }), propriétaire en tête puis par date : le reste de
// loadScanContext n'a pas à changer.
export function scansDuRegistre(claim) {
  if (!claim?.owner) return [];
  const autres = Object.entries(claim.seen || {})
    .filter(([uid]) => uid !== claim.owner)
    .map(([uid, date]) => ({ uid, date }))
    .sort((a, b) => secondes(a.date) - secondes(b.date));
  return [{ uid: claim.owner, date: claim.firstScanAt ?? claim.seen?.[claim.owner] ?? null }, ...autres];
}

export const registrePlein = (claim) => Object.keys(claim?.seen || {}).length >= SEEN_MAX;

// Création du registre par le 1er scanneur (état UNCLAIMED).
export function creationRegistre({ uid, aid }) {
  return { owner: uid, aid: String(aid), firstScanAt: serverTimestamp(), seen: { [uid]: serverTimestamp() } };
}

// Inscription d'un nouveau scanneur (état CLAIMED_UNSCANNED) : arguments de
// lot.update(ref, champ, valeur). FieldPath : un uid n'est pas un nom de champ
// sûr dans un chemin pointé.
export function inscriptionRegistre(uid) {
  return [new FieldPath("seen", uid), serverTimestamp()];
}
